/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest,
  FacilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest,
  FacilityFlowCoreModulesSupportDtosSupportTicketDto,
  FacilityFlowCoreModulesSupportDtosUpdateSupportTicketStatusRequest,
  GetApiV1SupportTicketsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getSupportTickets = () => {
const postApiV1SupportTickets = (
    facilityFlowCoreModulesSupportDtosCreateSupportTicketRequest: FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/support/tickets`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSupportDtosCreateSupportTicketRequest
    },
      options);
    }
  const getApiV1SupportTickets = (
    params?: GetApiV1SupportTicketsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto[]>(
      {url: `/api/v1/support/tickets`, method: 'GET',
        params
    },
      options);
    }
  const getApiV1SupportTicketsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/support/tickets/${id}`, method: 'GET'
    },
      options);
    }
  const patchApiV1SupportTicketsIdStatus = (
    id: string,
    facilityFlowCoreModulesSupportDtosUpdateSupportTicketStatusRequest: FacilityFlowCoreModulesSupportDtosUpdateSupportTicketStatusRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/support/tickets/${id}/status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSupportDtosUpdateSupportTicketStatusRequest
    },
      options);
    }
  const postApiV1SupportTicketsIdReplies = (
    id: string,
    facilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest: FacilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/support/tickets/${id}/replies`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest
    },
      options);
    }
  return {postApiV1SupportTickets,getApiV1SupportTickets,getApiV1SupportTicketsId,patchApiV1SupportTicketsIdStatus,postApiV1SupportTicketsIdReplies}};
export type PostApiV1SupportTicketsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSupportTickets>['postApiV1SupportTickets']>>>
export type GetApiV1SupportTicketsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSupportTickets>['getApiV1SupportTickets']>>>
export type GetApiV1SupportTicketsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSupportTickets>['getApiV1SupportTicketsId']>>>
export type PatchApiV1SupportTicketsIdStatusResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSupportTickets>['patchApiV1SupportTicketsIdStatus']>>>
export type PostApiV1SupportTicketsIdRepliesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getSupportTickets>['postApiV1SupportTicketsIdReplies']>>>
